import React from 'react';

const MapInfoBlock = () => {
    return (
        <div className="space-y-4">
            <div>
                <h4 className="font-medium text-gray-900 dark:text-white mb-2">Tipos de Polígonos</h4>
                <div className="grid grid-cols-1 gap-2">
                    <div className="flex items-center gap-3">
                        <div className="w-6 h-6 rounded bg-[#dcfce7] border border-[#166534] opacity-80 flex-shrink-0"></div>
                        <span className="text-sm text-gray-600 dark:text-gray-300">
                            <span className="font-medium text-gray-900 dark:text-white">Inclusión:</span> Zonas donde se permite el servicio.
                        </span>
                    </div>
                    <div className="flex items-center gap-3">
                        <div className="w-6 h-6 rounded bg-[#fee2e2] border border-[#991b1b] opacity-80 flex-shrink-0"></div>
                        <span className="text-sm text-gray-600 dark:text-gray-300">
                            <span className="font-medium text-gray-900 dark:text-white">Exclusión:</span> Zonas restringidas o sin servicio.
                        </span>
                    </div>
                </div>
            </div>

            <div>
                <h4 className="font-medium text-gray-900 dark:text-white mb-2">Interacciones</h4>
                <ul className="list-disc pl-5 space-y-1 text-sm text-gray-600 dark:text-gray-300">
                    <li>Haga clic en un polígono para ver sus detalles y editarlo.</li>
                    <li>Use el botón "Dibujar Polígono" para crear nuevas zonas manualmente.</li>
                    <li>Use "Convertir Comuna" para generar un polígono a partir de una comuna existente.</li>
                </ul>
            </div>
        </div>
    );
};

export default MapInfoBlock;
